import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import * as React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {Box, Tooltip} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoIcon from '@mui/icons-material/Info';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import * as _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    dictRepresentationMissing: {
        border: "1px solid #919191e6",
        padding: "7px 14px",
        borderRadius: "10px",
    },
    dictRepresentationMissingIcon: {
        color: "#f7bf57",
        cursor: "help"
    },
    dictMissingIcon: {
        color: "#f76666",
        cursor: "help"
    },
    dictInfoIcon: {
        color: "#66a5f7",
        cursor: "help"
    },
}));

export const DictionaryMissingElementTypes = {
    info: 0,
    warning: 1,
    error: 2
}

export function DictionaryMissingElementTableRenderer(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const [type, setType] = React.useState((<span/>));
    const [missingText, setMissingText] = React.useState("");


    React.useEffect(() => {
        if(props.type == 'info' || props.type == DictionaryMissingElementTypes.info){
            setType((<InfoIcon className={classes.dictInfoIcon}></InfoIcon>));
        }
        if(props.type == 'warning' || props.type == DictionaryMissingElementTypes.warning){
            setType((<WarningAmberIcon className={classes.dictRepresentationMissingIcon}/>));
        }
        if(props.type == 'error' || props.type == DictionaryMissingElementTypes.error){
            setType((<ErrorOutlineIcon className={classes.dictMissingIcon}/>));
        }
        if(props.missingText && props.missingText.length > 0){
            setMissingText(props.missingText);
        }
    }, [props.type, props.missingText])

    return (
        <Box sx={{
            display: 'inline-flex',
            flexWrap: 'nowrap',
            justifyContent: 'center'}}
             className={classes.dictRepresentationMissing}>
            <Box>
                {props.children}
            </Box>
            <Box sx={{
                width: "24px",
                height: "24px",
                paddingLeft: "6px"
            }}>
                <Tooltip title={missingText}>
                    {type}
                </Tooltip>
            </Box>
        </Box>
    )
}

const searchIdString = (item, config) => {
    if(typeof item == 'object'){
        if(item.hasOwnProperty("$oid")){
            return item["$oid"];
        }
        if(config.hasOwnProperty("idField") && item.hasOwnProperty(config.idField)){
            return searchIdString(item[config.idField], config);
        }
        if(config.hasOwnProperty("affectedIdField") && item.hasOwnProperty(config.affectedIdField)){
            return searchIdString(item[config.affectedIdField], config);
        }
    }
    if(typeof item == "string") {
        return item;
    }
    return null;
}

export const prepareDictArrayNames = (items, config, dict, dontSkipMissing = true) => {
    let retArr = [];
    items.forEach((item) => {
        if(item != null && item.hasOwnProperty(config.idField) && (typeof item[config.idField] == 'object') && item[config.idField].hasOwnProperty("$oid")){
            let idToFind = item[config.idField]["$oid"];
            if(idToFind != null){
                let dicItemFound = _.find(dict, (dictItem)=>{
                    if(dictItem.hasOwnProperty("$oid")){
                        return dictItem.$oid == idToFind;
                    }
                    return false;
                });
                if(dicItemFound != null && dicItemFound.hasOwnProperty(config.dictDisplayField)){
                    retArr.push(dicItemFound[config.dictDisplayField]);
                } else {
                    if(dontSkipMissing) retArr.push('-missing{' + idToFind + '}-');
                }
            } else {
                if(dontSkipMissing) {
                    console.error("incorrect item content, check DB or update");
                    retArr.push('-missing-item-');
                }
            }
        } else {
            if(typeof item == "object" && item.hasOwnProperty("$oid") || config.hasOwnProperty("affectedIdField") && item.hasOwnProperty(config["affectedIdField"])){
                let idToFind = searchIdString(item, config);
                if(idToFind != null) {
                    let dicItemFound = _.find(dict, (dictItem)=>{
                        if(dictItem.hasOwnProperty(config["idField"])){
                            if(dictItem[config["idField"]].hasOwnProperty("$oid")) {
                                return dictItem[config["idField"]]["$oid"] == idToFind;
                            }
                            return dictItem[config["idField"]] == idToFind;
                        }
                        return false;
                    });
                    if(dicItemFound != null && dicItemFound.hasOwnProperty(config.dictDisplayField)){
                        retArr.push(dicItemFound[config.dictDisplayField]);
                    } else {
                        if(dontSkipMissing) retArr.push('-missing{' + idToFind + '}-');
                    }
                } else {
                    if(dontSkipMissing) {
                        console.error("incorrect item content, check DB or update");
                        retArr.push('-missing-item-');
                    }
                }
            } else {
                if (typeof item == 'string') {
                    let dicItemFound = _.find(dict, (dictItem) => {
                        if (dictItem.hasOwnProperty(config.idField)) {
                            if (typeof dictItem[config.idField] == "object" && dictItem[config.idField].hasOwnProperty("$oid")) {
                                return dictItem[config.idField]["$oid"] == item;
                            } else {
                                return dictItem[config.idField] == item;
                            }
                        }
                        return false;
                    });
                    if (dicItemFound != null) {
                        if (dicItemFound.hasOwnProperty(config.dictDisplayField)) {
                            retArr.push(dicItemFound[config.dictDisplayField]);
                            //retArr.push(dicItemFound[config.idField]);
                        } else {
                            retArr.push(dicItemFound[config.idField]);
                        }
                    } else {
                        if(dontSkipMissing) retArr.push('-missing{' + item + '}-');
                    }
                } else {
                    if(dontSkipMissing) {
                        console.error("incorrect items");
                        retArr.push('-incorrect-item-');
                    }
                }
            }
        }
    });
    return retArr;
}

export const getStringValue = (item, field, joinSeparator = ",") => {
    if(typeof item == "object") {
        if(Array.isArray(field)){
            let itemValArr = [];
            _.forEach(field, fld => {
                itemValArr.push(getStringValue(item, fld, joinSeparator));
            });
            return itemValArr.join(joinSeparator);
        } else {
            if(typeof field == "string" || field == null){
                if(item.hasOwnProperty(field) || field == null){
                    const iValue = field == null ? item : item[field];
                    if(typeof iValue == "string") {
                        return iValue;
                    } else {
                        if(Array.isArray(iValue)) {
                            let iValueArr = [];
                            _.forEach(iValue, itv=> {
                                iValueArr.push(getStringValue(itv, null, joinSeparator));
                            });
                            return iValueArr.join(joinSeparator);
                        }
                        if(typeof iValue == "object"){
                            if(iValue.hasOwnProperty("$numberInt")){
                                return getStringValue(iValue, "$numberInt", joinSeparator);
                            } else {
                                if(iValue.hasOwnProperty("$numberDouble")){
                                    return getStringValue(iValue, "$numberDouble", joinSeparator);
                                } else {
                                    return JSON.stringify(iValue);
                                }
                            }
                        } else {
                            return JSON.stringify(iValue);
                        }
                    }
                } else {
                    //console.debug("function getStringValue", "item " + JSON.stringify(item) + " has missing property " + field);
                    return "";
                }
            }
        }
    } else {
        if(typeof item == "string"){
            return item;
        }
        //console.debug("function getStringValue", "item is no object " + JSON.stringify(item));
        return "";
    }
}